import React from 'react';

export function formatDateAsYyyyMmDd(value: Date): string {
    return value && value.toISOString().split('T')[0];
}

interface IDateProps {
    value: Date;
}

export default function FmtDate(props: IDateProps) {
    let value = props.value;
    return <>{formatDateAsYyyyMmDd(value)}</>
}